const OPEN_URL = "api/";

const EntityConstants = {
  CSRF_TOKEN: `${OPEN_URL}users/signup/`,
  SIGNUPHOLDER: `${OPEN_URL}users/signup/holder`,
  SIGNUPISSUER: `${OPEN_URL}users/signup/issuer`,
  LOGIN: `${OPEN_URL}users/login/`,
  LOGOUT: `${OPEN_URL}users/logout/`,
  CURRENT_USER: `${OPEN_URL}users/me/`,
  CURRENT_USER_UPDATE: `${OPEN_URL}users/me/update`,
  CURRENT_USER_PERMISSIONS: `${OPEN_URL}users/me/permissions`,
  ISSUER_PROJECT: `${OPEN_URL}users/me/issuer-project`,
  GET_ORGANISATION_DETAILS: `${OPEN_URL}users/assets`,
  ONBOARDING_APPLY: `${OPEN_URL}holder/claim/process`,
  CREDENTIALS: `${OPEN_URL}credentials/received`,
  DOWNLOAD_CREDENTIALS: `${OPEN_URL}credentials/presentation`,
  WORKFLOW: `${OPEN_URL}workflow/get-workflows/?tenant_id=`,
  DASH_APPLICATION: `${OPEN_URL}holderclaimprocess/list/?holder_id=`,
  FORMS: `${OPEN_URL}workflow/get-workflowsteps/?workflow_id=`,
  CONTINUE_FORM: `${OPEN_URL}claim/details/?holder_claim_process_id=`,
  APPLICATIONS: `${OPEN_URL}audit/applications/list`,
  APPLICATION_DETAIL: `${OPEN_URL}applications/details`,
  APPLICATION_REVIEW: `${OPEN_URL}audit/applications/review`,
  APPLICATION_REVIEW_SUBMIT: `${OPEN_URL}audit/applications/review`,
  APPLICATION_SUMMARY: `${OPEN_URL}onboarding/applications-summary`,
  APPLICATIONS_REVIEWED: `${OPEN_URL}audit/applications/reviewed`,
  AUDIT_APPLICATION_DETAIL: `${OPEN_URL}audit/applications/formdata`,
  AUDIT_CREDENTIAL_DETAIL: `${OPEN_URL}credentials/issued`,

  VERIFICATION_APPROVALS_EXPORT_EXCEL: `${OPEN_URL}credentials/verifications-approvals/export-excel`,
  VERIFICATION_APPROVALS_EXPORT_EXCEL_CREATE: `${OPEN_URL}credentials/verifications-approvals/export-excel/create`,

  DISCOVERY_SEARCH: `${OPEN_URL}credentials/search?search=`,
  DISCOVERY_TAG: `${OPEN_URL}credentials/tags`,

  DISCOVERY_TAG_SEARCH: `${OPEN_URL}credentials/templates?`,
  DISCOVERY_TEMPLATE: `${OPEN_URL}credentials/categories/templates?`,
  CREDENTIAL_TEMPLATE_DETAILS: `${OPEN_URL}credentials/templates/`,
  CREDENTIAL_TEMPLATE_ONBOARDING_DETAILS: `${OPEN_URL}workflow/get-workflowsteps/`,

  GET_CREDENTIALS_TEMPLATE_DESIGN: `${OPEN_URL}credentials/`,
  POST_CREDENTIALS_TEMPLATE_DESIGN: `${OPEN_URL}credentials/`,

  GET_CREDENTIALS_SUBJECT_FORM: `${OPEN_URL}credentials/`,

  POST_CREDENTIALS_SINGLE_ISSUANCE: `${OPEN_URL}credentials/issue/single?credential_template=`,
  POST_CREDENTIALS_BULK_ISSUANCE: `${OPEN_URL}credentials/issue/bulk?credential_template=`,

  GET_USER_PREVIEW_SVG: `${OPEN_URL}credentials/template/issuer`,

  GET_USER_PRESENTATION_SVG: `${OPEN_URL}credentials/presentation`,
  GET_USER_BULK_TRANSACTION_DETAILS: `${OPEN_URL}credentials/issued`,
  ACTIVATE_ACCOUNT: `${OPEN_URL}users/activate`,
  GET_TRANSACTIONS_DETAILS: `${OPEN_URL}credentials/v2/transactions/`,
  GET_TRANSACTIONS_INDIVIDUAL_DETAILS: `${OPEN_URL}credentials/transactions`,

  GET_ISSUER_DRAFTS: `${OPEN_URL}credentials/templates/issuer/`,
  GET_DRAFT_CERTIFICATE_DATA: `${OPEN_URL}credentials/template/issuer?issuer_credential_template_id=`,

  G_LOGIN: `${OPEN_URL}users/social-login/google`,
  MICROSOFT_LOGIN: `${OPEN_URL}users/social-login/microsoft`,
  MICROSOFT_AUTH_CODE:
    "https://login.microsoftonline.com/common/oauth2/v2.0/token",

  SEND_NOTIFICATION: `${OPEN_URL}notification/send`,

  GET_EMAIL_WHATSAPP_DEFAULT_DETAILS: `${OPEN_URL}credentials/`,

  GET_DEFAULT_EMAIL: `${OPEN_URL}notification/details?credential_id=`,

  DISCOVERY_DEFAULT_CATEGORY: `${OPEN_URL}credentials/categories`,
  DISCOVERY_SELECTED_TEMPLATES: `${OPEN_URL}credentials/categories/selected-templates`,

  TEMPLATE_PER_CATEGORY: `${OPEN_URL}credentials/categories/templates?`,

  GET_QR_IMAGE: `${OPEN_URL}users/settings/qr-code/logo`,

  POST_LOGO_FOR_QR: `${OPEN_URL}users/settings/qr-code/logo`,

  GET_ORG_DETAILS: `${OPEN_URL}users/settings/details`,

  POST_ORG_DETAILS: `${OPEN_URL}users/settings/details`,

  GET_ORG_DOMAIN_AVAILABILITY: `${OPEN_URL}users/settings/domain`,

  POST_USER_CATEGORIES: `${OPEN_URL}users/categories`,

  GET_DRAFTS_TEMPLATES: `${OPEN_URL}credentials/templates/issuer/?`,

  GET_BATCH_TEMPLATES: `${OPEN_URL}issuer/credentials/templates/batch`,

  DOWNLOAD_SVG_AS_ZIP: `${OPEN_URL}credentials/download?transaction_id=`,

  DOWNLOAD_SVG_AS_PNG: `${OPEN_URL}credentials/download?credential_id=`,

  REVOKE_CREDENTIAL: `${OPEN_URL}credentials/revoke`,

  GET_CREDENTIALS_COUNTS: `${OPEN_URL}issuers/metrics/stats`,

  GET_CREDENTIALS_BAR_CHART: `${OPEN_URL}issuers/metrics/trendschart`,

  GET_CREDENTIALS_PIE_CHART_STATUS: `${OPEN_URL}issuers/metrics/statusdistribution`,

  GET_CREDENTIALS_ISSUERS_LIST: `${OPEN_URL}issuers/metrics/issuerslist`,

  GET_ISSUANCE_REPORT: `${OPEN_URL}issuers/issuance/report`,

  GET_CREDENTIAL_JSON: `${OPEN_URL}credentials/credentials`,

  GET_REFRESH_ACCESS_TOKEN: `${OPEN_URL}users/token/refresh/`,

  GET_USERS_ORGANISATION_DETAILS: `${OPEN_URL}users/org/`,
  GET_ORGANISATION_CERTIFICATES: `${OPEN_URL}users/org/offerings?`,

  GET_CERTIFICATE_PREVIEW: `${OPEN_URL}credentials/verify`,
  GET_CREDENTIAL_STATUS_DETAILS: `${OPEN_URL}credentials/details`,
  GET_WALLET_OFFER: `${OPEN_URL}mdl/wallet-offer`,

  POST_FORGOT_PASSWORD: `${OPEN_URL}users/forgot-password/request`,
  POST_UPDATE_PASSWORD: `${OPEN_URL}users/update-password/update`,
  CHANGE_PASSWORD: `${OPEN_URL}users/change-password`,

  POST_TEST_EMAIL: `${OPEN_URL}users/email/identity/verify`,
  GET_EMAIL_DETAILS: `${OPEN_URL}users/email/identity`,
  POST_EMAIL_DETAILS: `${OPEN_URL}users/email/identity`,

  EMAIL_TEMPLATES: `${OPEN_URL}issuers/email/template`,

  PUT_REVOKE_DRAFT: `${OPEN_URL}credentials/template/issuer/update`,

  GET_PROGRAM_DETAILS: `${OPEN_URL}issuers/programme`,

  GET_VERIFICATION_APPROVALS_LIST: `${OPEN_URL}credentials/verification-approvals/`,

  GET_ISSUER_PROGRAMMES: `${OPEN_URL}credentials/issuer-programmes`,

  GET_VERIFIER_ORGANISATIONS_LIST: `${OPEN_URL}users/verifier-org/list`,

  POST_VERIFICATION_SETTINGS: `${OPEN_URL}issuers/verification-settings`,

  GET_PRE_ISSUANCE_HTML_PREVIEW: `${OPEN_URL}issuers/email/preview/pre-issuance`,

  GET_EMAIL_DETAILS_FOR_PREVIEW: `${OPEN_URL}issuers/email/metadata/pre-issuance`,

  GET_PROGRAMME_DETAILS: `${OPEN_URL}users/programme`,
  POST_CREATE_PROGRAMME: `${OPEN_URL}users/programme`,
  GET_PROGRAMME_NAME: `${OPEN_URL}users/programme/display-name`,

  GET_BATCH_DETAILS: `${OPEN_URL}users/batches`,
  POST_CREATE_BATCH: `${OPEN_URL}users/batches`,
  GET_BATCH_NAME: `${OPEN_URL}users/batches/display-name`,

  GET_ISSUER_CREDENTIAL_BATCH_TEMPLATES: `${OPEN_URL}credentials/issuer-template/batch`,

  GET_PENDING_ISSUANCE: `${OPEN_URL}credentials/legacy-issuance/transaction`,

  GET_RECIPIENTS: `${OPEN_URL}credentials/issued/issuer-credentials`,

  GET_ISSUANCE_STATUS: `${OPEN_URL}credentials/issuance-status`,

  GET_RECIPIENT_STATS: `${OPEN_URL}credentials/issued/issuer-credentials/stats`,

  POST_VERIFY_POST_ISSUANCE: `${OPEN_URL}credentials/verify/post-issuance`,

  POST_ZIP_PDF_UPLOAD: `${OPEN_URL}credentials/legacy-issuance/upload`,

  POST_VIEW_SUMMARY: `${OPEN_URL}credentials/legacy-issuance/validate`,
  GET_VIEW_SUMMARY: `${OPEN_URL}credentials/legacy-issuance/validate`,

  POST_LEGACY_ISSUANCE: `${OPEN_URL}credentials/issue/legacy_vc`,

  GET_USER_DETAILS_PRINT_CERTIFICATES: `${OPEN_URL}credentials/certificate-preview`,
  GET_USER_PDF_DETAILS: `${OPEN_URL}credentials/download/logs`,
  POST_REQUEST_CERTIFICATE: `${OPEN_URL}credentials/v2/download`,

  POST_ISSUANCE_EMAIL_METADATA: `${OPEN_URL}issuers/email/metadata/post-issuance`,

  POST_ISSUANCE_EMAIL_PREVIEW: `${OPEN_URL}issuers/email/preview/post-issuance`,

  SEND_EMAIL: `${OPEN_URL}notification/v2/send`,

  DOWNLOAD_SAMPLE_ZIP_EXCEL: `${OPEN_URL}credentials/legacy-issuance`,

  GET_PROGRAMME_BATCH_NAME: `${OPEN_URL}credentials/programme-batch-details`,

  DELETE_RECIPIENTS: `${OPEN_URL}credentials/delete`,

  GET_QR_COORDINATES: `${OPEN_URL}credentials/qr-coordinates`,
  POST_QR_COORDINATES: `${OPEN_URL}credentials/update/qr-coordinates`,

  DISCARD_PENDING_ISSUANCE: `${OPEN_URL}credentials/issuance/discard`,

  GET_VERIFICATION_DASHBOARD_STATS: `${OPEN_URL}issuers/verification-dashboard/status`,
  GET_VERIFICATION_DASHBOARD_APPROVAL_STATUS: `${OPEN_URL}issuers/verification-dashboard/approval-status`,
  GET_VERIFICATION_DASHBOARD_CHART_DATA: `${OPEN_URL}issuers/verification-dashboard/collections-verifications`,

  GET_ORGANISATIONS: `${OPEN_URL}users/tenant/orgs`,

  GET_TENANT_DATA: `${OPEN_URL}users/tenants`,
  POST_UPDATE_TENANT_STATUS: `${OPEN_URL}users/tenant/update-status`,
  POST_CREATE_TENANT: `${OPEN_URL}users/tenant/create`,
  GET_TENANT_ORGANISATIONS: `${OPEN_URL}users/tenant/orgs`,
  GET_TENANT_USERS: `${OPEN_URL}users/tenant/admins`,
  POST_TENANT_UPDATE_USER: `${OPEN_URL}users/tenant/admin/update-status`,
  POST_TENANT_UPDATE_ORGANISATION: `${OPEN_URL}users/tenant/org/update-status`,
  POST_CREATE_TENANT_ORGANISATION: `${OPEN_URL}users/tenant/org/create`,
  POST_CREATE_USERS: `${OPEN_URL}users/tenant/users`,
  GET_ORGANISATION_USERS: `${OPEN_URL}users/tenant/org/user`,
  CREATE_ORGANISATION_USERS: `${OPEN_URL}users/tenant/org/user/create`,
  POST_UPDATE_ORGANISATION: `${OPEN_URL}users/tenant/org/user/update-status`,

  TENANT_VERIFIER_APPROVALS: `${OPEN_URL}credentials/verifier-approvals`,

  VERIFIER_APPROVALS_EXPORT_EXCEL: `${OPEN_URL}credentials/verifier-approvals/export-excel`,
  VERIFIER_APPROVALS_EXPORT_EXCEL_CREATE: `${OPEN_URL}credentials/verifier-approvals/export-excel/create`,

  EMAIL_TEMPLATE_CLONE: `${OPEN_URL}issuers/email/template/clone`,

  VERIFICATION_REPORT_DETAILS: `${OPEN_URL}credentials/verification-report-details`,

  GET_VERIFICATION_REPORT_EMAIL_TEMPLATE: `${OPEN_URL}issuers/email/preview/pre-verification-approval`,

  GET_PRINT_STATS: `${OPEN_URL}credentials/print-stats`,
  GET_PRINT_DETAILS: `${OPEN_URL}credentials/print-details`,

  TRANSACTION_AUDIT_LOGS: `${OPEN_URL}credentials/verification-approval`,

  CERTIFICATE_ONBOARDING_UPLOAD: `${OPEN_URL}certificate-onboarding/upload`,
  CERTIFICATE_ONBOARDING_CLEANUP: `${OPEN_URL}certificate-onboarding/cleanup`,
  CERTIFICATE_ONBOARDING_UPDATE: `${OPEN_URL}certificate-onboarding/update`,
  CERTIFICATE_ONBOARDING_CREATE_FORM_SCHEMA: `${OPEN_URL}certificate-onboarding/create_form_schema`,
  CERTIFICATE_ONBOARDING_CATEGORIES: `${OPEN_URL}certificate-onboarding/categories`,
  CERTIFICATE_ONBOARDING_CREATE_CREDENTIALS: `${OPEN_URL}certificate-onboarding/credentials/create`,
  CERTIFICATE_ONBOARDING_SUGGEST_ENTITY_NAMES: `${OPEN_URL}certificate-onboarding/suggest-entity-names`,
  CERTIFICATE_ONBOARDING_VALIDATE_ENTITY_NAME: `${OPEN_URL}certificate-onboarding/validate-entity-name`,
  CERTIFICATE_ONBOARDING_PREPARE_FONTS: `${OPEN_URL}certificate-onboarding/prepare_fonts`,

  FINANCE_CAPABILITIES: `${OPEN_URL}finance/capabilities`,
  FINANCE_BILLING_SUMMARY: `${OPEN_URL}finance/billing/summary`,
  FINANCE_BILLING_TREND: `${OPEN_URL}finance/billing/trend`,
  FINANCE_BILLING_REPORT: `${OPEN_URL}finance/billing/report`,
  FINANCE_BILLING_REPORT_EXPORT: `${OPEN_URL}finance/billing/report/export`,
  FINANCE_SETTLEMENT_SUMMARY: `${OPEN_URL}finance/settlement/summary`,
  FINANCE_SETTLEMENT_TREND: `${OPEN_URL}finance/settlement/trend`,
  FINANCE_SETTLEMENT_REPORT: `${OPEN_URL}finance/settlement/report`,
  FINANCE_SETTLEMENT_REPORT_EXPORT: `${OPEN_URL}finance/settlement/report/export`,

  GET_HOLDERS: `${OPEN_URL}issuers/holders`,
  GET_HOLDER_DETAILS: `${OPEN_URL}issuers/holders/`,

  WHITE_LABEL_CONFIG_STATUS: `${OPEN_URL}white-label/config-status`,
  WHITE_LABEL_STATUS: `${OPEN_URL}white-label/status`,
  WHITE_LABEL_SUBMIT: `${OPEN_URL}white-label/submit`,
  WHITE_LABEL_RETRIGGER: `${OPEN_URL}white-label/retrigger`,
  WHITE_LABEL_REMOVE: `${OPEN_URL}white-label/remove`,

  HTML_DESIGNS_LIST: `${OPEN_URL}html-designs`,
  HTML_DESIGNS: `${OPEN_URL}html-designs/`,
  HTML_DESIGNS_ASSETS: `${OPEN_URL}html-designs/assets/`,
  AI_DESIGN_VARIANTS: `${OPEN_URL}ai/design-variants/`,
  AI_ANALYZE_REFERENCE: `${OPEN_URL}ai/analyze-reference/`,
};
export default EntityConstants;
